import React, { useState } from "react";
import { Pencil } from "lucide-react";
import "../Css/PreviewMainForm.css";
import { useDispatch } from "react-redux";
import { setActiveTabIndex } from "../actions";
import {
  server_post_data,
  maintainance_car_data,
  APL_LINK,
} from "../../ServiceConnection/serviceconnection";
import {
  handleError,
  handleSuccess,
  handleSuccessSession,
} from "../../CommonJquery/CommonJquery";
import { useNavigate } from "react-router-dom";
const PreviewMainForm = ({
  onBack,
  MaintainanceData,
    BookingData,
  cardata,
  ImageLink,
  ImageLinkIpass,
  FromComeData,
}) => {
  const dispatch = useDispatch();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    safetyCheck: {
      brakesWorking: "Yes",
      lightsWorking: "Yes",
      hornWorking: "Yes",
      wipersFunctional: "Yes",
      seatsSecured: "Yes",
      editing: false,
    },
    tireInspection: {
      tirePressureOk: "Yes",
      tireWearAcceptable: "Yes",
      spareTirePresent: "Yes",
      allTiresMatched: "Yes",
      editing: false,
    },
    fluidCheck: {
      engineOilLevel: "Normal",
      brakeFluidLevel: "Normal",
      coolantLevel: "Normal",
      washerFluidLevel: "Normal",
      editing: false,
    },
    lightCheck: {
      headlightsWorking: "Yes",
      taillightsWorking: "Yes",
      indicatorsWorking: "Yes",
      hazardLightsWorking: "Yes",
      editing: false,
    },
    oilCheck: {
      oilLevelOk: "Yes",
      oilQualityGood: "Yes",
      oilFilterReplaced: "No",
      oilLeakPresent: "No",
      editing: false,
    },
    notes: "Regular maintenance completed. Vehicle in good condition.",
    editingNotes: false,
  });

  const handleEdit = (section) => {
    switch (section) {
      case "generalInfo":
        dispatch(setActiveTabIndex(1));
        break;
      case "lightCheck":
        dispatch(setActiveTabIndex(2));
        break;
      case "oilCheck":
        dispatch(setActiveTabIndex(3));
        break;
      case "tireInspection":
        dispatch(setActiveTabIndex(4));
        break;
      case "fluidsCheck":
        dispatch(setActiveTabIndex(5));
        break;
      case "carInspection":
        dispatch(setActiveTabIndex(6));
        break;
      case "safetyChecks":
        dispatch(setActiveTabIndex(7));
        break;
      case "finalChecks":
        dispatch(setActiveTabIndex(8));
        break;
      default:
        //console.log("Invalid section");
    }
  };
  // //console.log("djkasjdlasjdlasd",MaintainanceData)
  const toggleEdit = () => {
    //console.log("toggleEdit");
  };

  const toggleEditNotes = () => {
    //console.log("toggleEdit");
  };

  const handleclickSubmit = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("car_id", cardata.primary_id);
    fd.append("step_for_maintenance", 8);
    fd.append(" ", MaintainanceData?.primary_id || 0);
    fd.append("save_or_edit_type", FromComeData);
    await server_post_data(maintainance_car_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          
          handleSuccess(Response.data.message);
          // handleSuccessSession('/Maintanance', Response.data.message)
          navigate("/Maintanance");
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // genral Info Section
  const genralinfoSection = () => {
    const { safetyCheck } = formData;
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Genral Info</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("generalInfo")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Maintenance Information</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reason</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.maintenance_reasion}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Done By</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.assign_staff_name}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Issue with the car
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.name_and_issue}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Light Check  Section
  const LightCheckSection = () => {
    const { tireInspection } = formData;
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Light Check</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("lightCheck")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <h4 className="border-bottom py-2">Tail Lights</h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.tail_right}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.tail_left}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reverse Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_reverse_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reverse Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_reverse_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_binker_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_binker_left}
                </span>
              </div>
            </div>

            <h4 className="border-bottom py-2 mt-3">Front Lights</h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Right Low</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_right_low}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Left High</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_left_high}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Right High</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_right_high}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Left Low</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_left_low}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.blinker_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.blinker_left}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Oil Check Section
  const OilCheckSection = () => {
    const { fluidCheck } = formData;
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Oil Check</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("oilCheck")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Day Since Last Oil Check</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Day Since Last Oil Check
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.days_age} Days
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Level</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.oil_level}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Quality</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.oil_quantity}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Oil Added(Quantity in Quats)
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.oil_added_quantity}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Change By</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.oil_changed_by}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Picture of closed Oil Cap
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={ImageLink + MaintainanceData.picture_of_closed_oil}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Tire Inpection Section
  const TireInspectionSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Tire Inspection</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("tireInspection")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <h4 className="border-bottom py-2">Tire Air Pressure(35-40PSI)</h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_front_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_front_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_rear_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_rear_right}
                </span>
              </div>
            </div>

            <h4 className="border-bottom py-2 mt-3">
              Tire Tread Depth | Tire Position
            </h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_front_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_front_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_rear_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_rear_right}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Tire Action</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.tire}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Replaced Tire</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.replace_tire}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // Fluid Check  Section
  const FluidCheckSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Fluids Check</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("fluidsCheck")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Day Since Last Oil Check</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Break Fluid</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.break_fluid}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Coolant</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.coolant_fluid}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Windshild Washer
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.windshield_washer}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Check Gas Cap</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={ImageLink + MaintainanceData.check_gas_cap}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // Car Inspection   Section
  const CarInspectionSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Car Inspection</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("carInspection")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Day Since Last Oil Check</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Finder Liners/Engine Liners
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.fender_liners}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">City Sticker</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.city_stiker}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Take Picture of the City Sticker
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={ImageLink + MaintainanceData.city_sticker}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Heating & Ac Check
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.ac_check}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Reset Maintenance
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.reset_maintainance}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Odometer Reading
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.odo_metter}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">IPASS Number</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.last_5_digit_ipass}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Take Picture of IPASS
              </label>
              {console.log(ImageLinkIpass + MaintainanceData.ipass_image)}
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={ImageLinkIpass + MaintainanceData.ipass_image}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // Final Check   Section
  const SafetyCheckSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Dashboard & Safety Checks</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("safetyChecks")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Dashboard Warning Lights
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.dashboard_safety}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Picture of Dashboard
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={ImageLink + MaintainanceData.dashboard_image}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Horn Functionality
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.horn_working}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Phone Charging
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.phone_charging}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Wiper Blades</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.wiper_blade}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Wiper Working</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.wiper_working}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // Safety Check   Section
  const FinalCheckSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Final Check</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("finalChecks")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Code Reading Image
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="row">
                  {[1, 2, 3, 4].map((i) => {
                    const imageKey = `coderead_image${i}`;
                    const imageUrl = MaintainanceData[imageKey];

                    if (imageUrl) {
                      return (
                        <div className="col-3" key={i}>
                          <img
                            src={ImageLink + imageUrl}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                            alt={`Image ${i}`}
                            className="img-fluid"
                          />
                        </div>
                      );
                    }

                    return null;
                  })}
                </div>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Remarks for Codes on Dashboard
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.remark_dashboard_code}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Damage</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.damage_status == "someDamage"
                    ? "Yes"
                    : "No"}
                </span>
              </div>
              {/*--------if yes --------- */}
              {MaintainanceData.damage_status == "someDamage" && (
                <div className="field-value-container d-flex justify-content-end YesDamage">
                  <div className="row">
                    {[1, 2, 3, 4].map((i) => {
                      const imageKey = `damage_image${i}`;
                      const imageUrl = MaintainanceData[imageKey];

                      if (imageUrl) {
                        return (
                          <div className="col-3" key={i}>
                            <img
                              src={ImageLink + imageUrl}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                              alt={`Image ${i}`}
                              className="img-fluid"
                            />
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>
              )}
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Seat Cover Installed
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.seat_cover}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Check if Driver has Oil Bottles
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.driver_oil_bottles}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Snow Brush in Car
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.snow_brush}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Come to Office to Verify 2nd Key
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.office_verify}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Details of Repair Done
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.details_for_repair}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Pictures of repairs
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="row">
                  {MaintainanceData.pictures_of_repairs
                    ?.split("@@@")
                    .filter((item) => item !== "" && item !== "0")
                    .map((imageName, index) => (
                      <div className="col-3" key={index}>
                        <img
                          src={ImageLink + imageName}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          alt={`Repair ${index + 1}`}
                          className="img-fluid"
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Notes for Future
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.notes_for_future}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="final-checks-container">
      <div className="form-header mb-4">
        <h2 className="form-title mb-2">Final Vehicle Inspection Checklist</h2>
        <p className="form-subtitle text-muted">
          Verify all inspections have been completed before submitting
        </p>
      </div>

      {genralinfoSection()}
      {LightCheckSection()}
      {OilCheckSection()}
      {TireInspectionSection()}
      {FluidCheckSection()}
      {CarInspectionSection()}
      {SafetyCheckSection()}
      {FinalCheckSection()}

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>

        <button className="btn next__button" onClick={handleclickSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default PreviewMainForm;
